import { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import { LearningGoal } from '../types';

interface LearningGoalCardProps {
  goal: LearningGoal;
}

const LearningGoalCard = ({ goal }: LearningGoalCardProps) => {
  const [animatedProgress, setAnimatedProgress] = useState(0);

  useEffect(() => {
    const timer = setTimeout(() => {
      setAnimatedProgress(goal.progress);
    }, 100);
    return () => clearTimeout(timer);
  }, [goal.progress]);

  return (
    <div className="bg-surface rounded-lg p-6 border border-border hover:border-primary/50 transition-all duration-300">
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center gap-3">
          <div
            className="w-10 h-10 rounded-lg flex items-center justify-center"
            style={{ backgroundColor: `${goal.color}20` }}
          >
            <Icon name={goal.icon} size={20} color={goal.color} />
          </div>
          <div>
            <h3 className="text-lg font-semibold text-foreground">{goal.technology}</h3>
            <p className="text-sm text-muted-foreground">Target: {goal.targetDate}</p>
          </div>
        </div>
        <div className="text-2xl font-bold text-primary">{goal.progress}%</div>
      </div>

      <div className="mb-4">
        <div className="w-full h-3 bg-muted rounded-full overflow-hidden">
          <div
            className="h-full rounded-full transition-all duration-1000 ease-out"
            style={{
              width: `${animatedProgress}%`,
              backgroundColor: goal.color,
            }}
          />
        </div>
      </div>

      <div className="flex items-center gap-2 text-sm text-muted-foreground">
        <Icon name="Target" size={16} />
        <span>In Progress</span>
      </div>
    </div>
  );
};

export default LearningGoalCard;